import React, { useEffect, useState } from 'react';
import {
  TopicDiv,
  NewTopic,
  NewButton,
  ActiveTopic,
  NewTopicDesc,
  Desc,
  Wrapper,
  Heading,
  ActiveTopicDiv,
  NewTopicSpan,
} from '../TopicBuilder/MainContent/HomePage/HomePage.styled';

import { useDispatch, useSelector } from 'react-redux';
import { activeTopicList, setPopUpActive } from '../../store/redux/slices/topicSlice';
import { useNavigate } from 'react-router-dom';
import { competitiveIntelligenceList, updateShowSideBar } from '../../store/redux/slices/competitiveIntelligenceSlice';
import styled from 'styled-components';

const ActiveAnalysisDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #0D7362 0%, #4D9F47 100%);
  width: 138px;
  height: 84px; 
  border-radius: 10px;
  box-shadow: 0px 4px 4px 0px rgba(14, 88, 152, 0.25);
  color:white;
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  padding: 15px 20px;
`;


function HomePage({topicList,chatterList}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAnalysisClick = (ci_id) => {
    navigate('/competitiveIntelligence/ci_' + ci_id);
  // const { activeTopicListData } = useSelector((state) => state.topicBuilder) || [];
  // if (activeTopicListData === null) {
  //   dispatch(activeTopicList());
  // }

  // const handleTopicClick = (job_id) => {
  //   navigate('/competitiveIntelligence/job_'+job_id)

  };

  const handleChangePage = () => {
    dispatch(updateShowSideBar('topic'))
    dispatch(setPopUpActive(true))
    navigate('/competitiveIntelligence/create')
  }

  const mergedList = [...(topicList || []), ...(chatterList || [])];
  return (
    <Wrapper>
      <TopicDiv>Competitive Intelligence</TopicDiv>
      <Desc> Turn Market Intelligence into Actionable Strategies</Desc>
      <NewTopic>
        <NewTopicSpan>Brand Comparison Dashboard</NewTopicSpan>
        <NewTopicDesc>
        Compare brand performance over time or against competitors by analyzing active or hibernated Topics, Chatters, and News Sources. Identify engagement shifts, competitive gaps, and emerging trends across channels.        </NewTopicDesc>
        <NewButton onClick={() => handleChangePage()}>
          Compare
        </NewButton>
      </NewTopic>
      <ActiveTopic>
        <Heading>Report Navigator</Heading>
        <div className='topicWrapper'>
          {mergedList?.map((el) => (
            <ActiveAnalysisDiv
              key={el.job_id}
              onClick={() => handleAnalysisClick(el.competitive_intelligence_id)}
            >
              <p title={el.chatter_topic_title_1} style={{textAlign:'center'}}>{el.chatter_topic_title_1?.length > 17 ? el.chatter_topic_title_1?.slice(0, 17) + '...' : el.chatter_topic_title_1}</p>
              
              <div style={{fontSize:'12px'}}>vs</div>
              {/* <hr style={{width: '90%',color:'white', display: 'inline-block', verticalAlign: 'middle', margin: '0 10px',border: 'none', borderTop: '1px solid #36363c'}}></hr> */}
              <p title={el.chatter_topic_title_2} style={{textAlign:'center'}}>{el.chatter_topic_title_2?.length > 17 ? el.chatter_topic_title_2?.slice(0, 17) + '...' : el.chatter_topic_title_2}</p>
            </ActiveAnalysisDiv>
          ))}
        </div>
      </ActiveTopic>
      
      
    </Wrapper>
  );
}

export default HomePage;
